export default __webpack_public_path__ + "static/media/online-shopping-logo-2.faf3407d.png";